import React from "react";
import { AiOutlineBell, AiOutlineMenu, AiOutlineSetting } from "react-icons/ai";

export default function Navbaradmin() {
  return (
    <header className="sticky top-0 z-20 border-b border-slate-200 bg-white/90 px-4 py-3 backdrop-blur sm:px-6 lg:px-8">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <button
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 text-slate-600 md:hidden"
            aria-label="Open navigation"
          >
            <AiOutlineMenu className="text-xl" />
          </button>
          <div>
            <p className="text-sm text-slate-500">Welcome back</p>
            <h2 className="text-lg font-bold text-slate-950">Admin workspace</h2>
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 text-slate-600 transition hover:bg-slate-50"
            aria-label="Notifications"
          >
            <AiOutlineBell className="text-xl" />
          </button>
          <button
            className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 text-slate-600 transition hover:bg-slate-50"
            aria-label="Settings"
          >
            <AiOutlineSetting className="text-xl" />
          </button>
          <div className="ml-1 hidden items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 py-1.5 pl-2 pr-3 sm:flex">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-950 text-xs font-bold text-white">
              AD
            </div>
            <div>
              <p className="text-sm font-semibold leading-tight text-slate-950">Admin</p>
              <p className="text-xs leading-tight text-slate-500">Owner</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
